import { cn } from '@/lib/utils'

type AuroraTone = 'hero' | 'section' | 'cta'

const BLOBS: Record<AuroraTone, string[]> = {
  hero: [
    'animate-aurora-a -top-[38%] right-[-18%] h-[1100px] w-[1100px] bg-[radial-gradient(circle_at_center,rgba(0,229,255,0.17),rgba(0,229,255,0.05)_38%,transparent_62%)]',
    'animate-aurora-b -left-[22%] top-[6%] h-[900px] w-[900px] bg-[radial-gradient(circle_at_center,rgba(37,99,235,0.13),transparent_60%)]',
    'bottom-[-40%] left-[28%] h-[760px] w-[760px] bg-[radial-gradient(circle_at_center,rgba(252,211,77,0.06),transparent_58%)]',
  ],
  section: [
    'animate-aurora-a -top-[30%] left-[10%] h-[760px] w-[760px] bg-[radial-gradient(circle_at_center,rgba(0,229,255,0.08),transparent_60%)]',
  ],
  cta: [
    'animate-aurora-a left-1/2 top-[58%] h-[900px] w-[1300px] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(ellipse_at_center,rgba(0,229,255,0.2),rgba(0,229,255,0.05)_42%,transparent_64%)]',
    'animate-aurora-b left-[6%] top-[62%] h-[620px] w-[620px] -translate-y-1/2 bg-[radial-gradient(circle_at_center,rgba(252,211,77,0.07),transparent_60%)]',
  ],
}

export function Aurora({
  tone = 'hero',
  grid = true,
  className,
}: {
  tone?: AuroraTone
  grid?: boolean
  className?: string
}) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-0 overflow-hidden',
        tone === 'hero' && '[mask-image:linear-gradient(to_bottom,black_72%,transparent)]',
        tone === 'cta' &&
          '[mask-image:linear-gradient(to_bottom,transparent,black_22%,black_72%,transparent)]',
        className,
      )}
    >
      {grid && (
        <div className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_75%_60%_at_50%_0%,black,transparent_78%)]" />
      )}
      {BLOBS[tone].map((blob) => (
        <div key={blob} className={cn('absolute rounded-full', blob)} />
      ))}
      <div className="absolute inset-0 bg-noise opacity-[0.04] mix-blend-overlay" />
    </div>
  )
}

export function GlowLine({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'pointer-events-none block h-px bg-gradient-to-r from-transparent via-[var(--color-brand-accent)]/60 to-transparent',
        className,
      )}
    />
  )
}
